import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box, Typography } from '@material-ui/core';

import { TaxonomyForm } from '../../components/TaxonomyForm';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';
import { useStyles } from './useStyles';

export const AnywordDatasetPanel = ({ className, error }) => {
  const styles = useStyles();

  const { handleChange } = useHandlers();
  const { selectedTaxonomyId } = useViewState();

  return (
    <Box className={cx(styles.root, className)}>
      <Typography className={styles.description}>
        Select from one of our scoring models that fits your product or service best.
      </Typography>

      <TaxonomyForm
        value={selectedTaxonomyId}
        onChange={handleChange}
        error={error}
      />
    </Box>
  );
};

AnywordDatasetPanel.propTypes = {
  className: PropTypes.string,
  error: PropTypes.bool,
};
AnywordDatasetPanel.defaultProps = {
  className: '',
  error: false,
};
